import Button from 'components/Button'
import React from 'react'
import Flex from 'components/Flex'
import Group from 'components/Images/Group.png'
import {
  Content,
  Heading,
  Para,
} from 'modules/Onboarding/Components/RegisterSuccessful/RegisterSuccessfulPage/style'

const InstituteLinkGenerationDetails = () => {
  return (
  
      <Content alignCenter column center>
        <Flex>
          <img src={Group} alt='group'/>
        </Flex>
        <Flex column>
          <Heading center>Institute added Successfully.</Heading>
          <Para>
            Institute added and credential send successfully to the respective
            institute mail.
          </Para>
        </Flex>
        <Button.Primary center htmlType="submit" text="Continue Onboarding" />
      </Content>
    
  )
}

export default InstituteLinkGenerationDetails
